import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { loginService } from "../../services/loginService";
import Swal from "sweetalert2";
import { PulseLoader } from "react-spinners";
import { Icon } from "@ui5/webcomponents-react";
import textos from "../../assets/textos.json";

import styles from "../../css/general.module.css";
import ReactTooltip from "react-tooltip";

export function Login() {
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [loading, setLoading] = useState(false);
  const [showHiden, setShowHiden] = useState("hide");
  const navigate = useNavigate();

  const handleShowHiden = () => {
    if (showHiden === "hide") {
      setShowHiden("show");
      document.getElementById("password").type = "text";
    } else {
      setShowHiden("hide");
      document.getElementById("password").type = "password";
    }
  };

  const handleLogin = () => {
    if (user === "" || pass === "") {
      Swal.fire({
        title: "Datos Incompletos",
        text: "¡Debe ingresar toda la información para poder continuar!",
        confirmButtonColor: "#005DC9",
        confirmButtonText: "Siguiente",
        icon: "error",
      });
    } else {
      setLoading(true); //Se carga con TRUE para que se muestre el sppiner
      loginService(user, pass).then(resolve, reject); //Login

      function resolve(data) {
        if (Array.isArray(data)) {
          //Solo los usuarios con estado "05" se pueden logear
          if (data[0].ID_ESTADO === "05") {
            sessionStorage.setItem("VALOREM_APP", data[0].USUARIO); //Se guarda el nombre de usuario en Sesion Storage

            let fechaVencimiento = new Date(
              data[0].FECHA_VENCIMIENTO
            ).toLocaleDateString();

            navigate("/home");
            setLoading(false); //Se carga con FALSE para que se deje de mostrar el sppiner

            //Se muestra alerta con información del usuario logeado
            Swal.fire({
              title: `Bienvenido ${data[0].USUARIO}`,
              text: `Fecha vencimiento clave: ${fechaVencimiento}`,
              confirmButtonColor: "#005DC9",
              confirmButtonText: "Siguiente",
              icon: "success",
            });
          } else {
            navigate("/");
            setLoading(false); //Se carga con FALSE para que se deje de muestre el sppiner

            //Se muestra alerta con el error que devolvio la API
            Swal.fire({
              title: data[0].USUARIO,
              text: data[0].NM_ESTADO,
              confirmButtonColor: "#005DC9",
              confirmButtonText: "Siguiente",
              icon: "error",
            });
          }
        } else {
          navigate("/");
          setLoading(false); //Se carga con FALSE para que se deje de muestre el sppiner

          //Se muestra alerta con el error que devolvio la API
          Swal.fire({
            title: data.hasOwnProperty("ClassName") ? data.ClassName : "Error",
            text: data.hasOwnProperty("Message")
              ? data.Message
              : "Comuniquese con soporte.",
            confirmButtonColor: "#005DC9",
            confirmButtonText: "Siguiente",
            icon: "error",
          });
        }
      }

      function reject(data) {
        navigate("/");
        setLoading(false); //Se carga con FALSE para que se deje de muestre el sppiner
        console.log(data);

        //Se muestra alerta con el error que devolvio la API
        Swal.fire({
          title: data.hasOwnProperty("code") ? data.code : "Error",
          text: data.hasOwnProperty("Message")
            ? data.Message
            : "Comuniquese con soporte.",
          confirmButtonColor: "#005DC9",
          confirmButtonText: "Cerrar",
          icon: "error",
        });
      }
    }
  };

  return (
    <>
      {loading ? (
        <div className={styles.containerSppiner}>
          <PulseLoader className={styles.sppiner} color="#005dc9" size={50} />
        </div>
      ) : (
        ""
      )}
      <div className={styles.contenedor}>
        <h1>{textos.titles.portal}</h1>
        <input
          id="user"
          type="text"
          placeholder={textos.place_holders.user}
          className={styles.input}
          onChange={(e) => {
            setUser(e.target.value.toUpperCase().trim());
            document.getElementById("user").value =
              e.target.value.toUpperCase();
          }}
        />
        <div className={styles.containerPass}>
          <input
            id="password"
            type="password"
            placeholder={textos.place_holders.password}
            className={styles.inputPassword}
            onChange={(e) => {
              setPass(e.target.value.trim());
            }}
          />
          <Icon
            className={styles.icon}
            name={showHiden}
            onClick={handleShowHiden}
          />
        </div>
        <div className={styles.grupoBotones}>
          <button
            className={styles.boton}
            onClick={() => {
              handleLogin();
            }}
          >
            {textos.buttons.init_session}
          </button>
          <Link to="/change-password">
            <button
              className={styles.boton}
              data-tip
              data-for="change-password"
            >
              {textos.buttons.changePass}
            </button>
          </Link>
          <Link to="/unlock-user">
            <button className={styles.boton} data-tip data-for="unlock-user">
              {textos.buttons.unblock_user}
            </button>
          </Link>
          <Link to="/reset-pass">
            <button className={styles.boton} data-tip data-for="reset-pass">
              {textos.buttons.reset_pass}
            </button>
          </Link>
        </div>
      </div>
      <ReactTooltip id="change-password" place="bottom" type="dark">
        Utilice esta opción si requiere cambiar su contraseña antes de la fecha
        límite de su expiración.
      </ReactTooltip>
      <ReactTooltip id="unlock-user" place="bottom" type="dark">
        Utilice esta opción si ingresó erradamente su contraseña más de 3 veces.
      </ReactTooltip>
      <ReactTooltip id="reset-pass" place="bottom" type="dark">
        Utilice esta opción si olvido su contraseña o expiró y es necesario
        asignar una nueva.
      </ReactTooltip>
    </>
  );
}
